export const API_URL={
    product_registration: "/productregistration",
    contact_registration: "/contactinformations",
    warranty_activation:"/warrantyregistration"
}